import { render, staticRenderFns } from "./total-sale-item.vue?vue&type=template&id=04acf7d8&scoped=true"
import script from "./total-sale-item.vue?vue&type=script&lang=js"
export * from "./total-sale-item.vue?vue&type=script&lang=js"
import style0 from "./total-sale-item.vue?vue&type=style&index=0&id=04acf7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04acf7d8",
  null
  
)

export default component.exports